(function(){
  if (window.__bbFall) return; window.__bbFall = true;
  function money(cents, fmt){
    var v=(cents/100).toFixed(2);
    return (fmt||'${{amount}}').replace(/\{\{\s*amount\s*\}\}/, v).replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents/100));
  }
  function toast(root,msg){var t=root.querySelector('[data-bbf-toast]');if(!t)return;t.textContent=msg;t.classList.add('show');clearTimeout(t._t);t._t=setTimeout(function(){t.classList.remove('show')},2200)}
  function initMaple(root){
    var data=JSON.parse(root.querySelector('[data-bbf-variants]').textContent);
    var fmt=root.getAttribute('data-money-format');
    var input=root.querySelector('[data-bbf-variant]');
    var cur=data.find(function(v){return String(v.id)===input.value})||data[0];
    var state={color:cur.color,size:cur.size};
    var img=root.querySelector('[data-bbf-img]');
    var atc=root.querySelector('[data-bbf-atc]');
    function render(swap){
      var v=data.find(function(x){return x.color===state.color&&x.size===state.size});
      root.querySelectorAll('.bbf-sw,.bbf-thumb').forEach(function(b){b.classList.toggle('is-active',b.dataset.color===state.color)});
      root.querySelectorAll('.bbf-size').forEach(function(b){
        b.classList.toggle('is-active',b.dataset.size===state.size);
        var ok=data.some(function(x){return x.color===state.color&&x.size===b.dataset.size&&x.available});
        b.style.opacity=ok?'':'.45';
      });
      var cl=root.querySelector('[data-bbf-color-label]');if(cl)cl.textContent=state.color;
      var sl=root.querySelector('[data-bbf-size-label]');if(sl)sl.textContent=state.size;
      if(!v){atc.disabled=true;atc.textContent='Unavailable';return}
      input.value=v.id;
      root.querySelector('[data-bbf-price]').textContent=money(v.price,fmt);
      atc.disabled=!v.available;atc.textContent=v.available?(atc.dataset.label||'Add to Cart'):'Sold out';
      if(v.img&&img.src.indexOf(v.img.split('?')[0].split('/').pop())===-1){
        if(swap){img.classList.add('swap');setTimeout(function(){img.src=v.img;img.alt=img.alt.replace(/ in .*$/,'')+' in '+v.color;img.classList.remove('swap')},250)}else img.src=v.img;
      }
    }
    atc.dataset.label=atc.textContent.trim();
    root.querySelectorAll('.bbf-sw,.bbf-thumb').forEach(function(b){b.addEventListener('click',function(){if(state.color!==b.dataset.color){state.color=b.dataset.color;render(true)}})});
    root.querySelectorAll('.bbf-size').forEach(function(b){b.addEventListener('click',function(){state.size=b.dataset.size;render(false)})});
    var form=root.querySelector('.bbf-maple__form');
    form.addEventListener('submit',function(e){
      e.preventDefault();
      atc.disabled=true;var lbl=atc.textContent;atc.textContent='Adding…';
      fetch((window.Shopify&&Shopify.routes?Shopify.routes.root:'/')+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:Number(input.value),quantity:1}]})})
      .then(function(r){if(!r.ok)throw r;return r.json()})
      .then(function(){
        atc.textContent='Added to cart';toast(root,'Added to your cart');
        fetch('/cart.js').then(function(r){return r.json()}).then(function(c){
          document.querySelectorAll('.cart-count-bubble span[aria-hidden="true"]').forEach(function(s){s.textContent=c.item_count});
          document.dispatchEvent(new CustomEvent('cart:refresh',{detail:c}));
        });
        setTimeout(function(){atc.textContent=lbl;atc.disabled=false},1800);
      })
      .catch(function(){form.submit()});
    });
    render(false);
  }
  function init(){
    document.querySelectorAll('[data-bbf-maple]').forEach(function(r){if(!r._bbf){r._bbf=1;initMaple(r)}});
    document.querySelectorAll('[data-bbf-copy]').forEach(function(b){if(b._bbf)return;b._bbf=1;b.addEventListener('click',function(){
      var c=b.dataset.bbfCopy;if(navigator.clipboard)navigator.clipboard.writeText(c).catch(function(){});
      b.textContent='Copied';toast(b.closest('.bbf'),c+' copied to clipboard');setTimeout(function(){b.textContent='Copy'},1800);
    })});
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
  document.addEventListener('shopify:section:load',init);
})();
